import configure from "./config";
export default configure();
